import React from "react";

// Updated data structure to include captions for better storytelling
const images = [
  {
    id: 1,
    src: require("../assets/img-gal-1.jpeg"),
    alt: "Team Collaboration",
    caption: "Collaborating with the AIA Team",
  },
  {
    id: 2,
    src: require("../assets/img-gal-2.jpeg"),
    alt: "Office Interior",
    caption: "Our Dedicated Workspace",
  },
  {
    id: 3,
    src: require("../assets/img-gal-3.jpeg"),
    alt: "Project Launch",
    caption: "Launching New Protection Plans",
  },
  {
    id: 4,
    src: require("../assets/img-gal-4.jpeg"),
    alt: "Client Meeting",
    caption: "Personal Wealth Consultations",
  },
  {
    id: 5,
    src: require("../assets/img-gal-5.jpeg"),
    alt: "Awards Night",
    caption: "Celebrating Excellence & MDRT",
  },
].filter((img) => img.src);

export default function Gallery() {
  if (images.length === 0) return null;

  return (
    <section id="gallery" className="bg-white py-24">
      <div className="mx-auto max-w-7xl px-6">
        {/* Header Section */}
        <div className="mb-16 text-center sm:text-left">
          <span className="text-red-600 font-bold tracking-widest uppercase text-sm">
            Visuals
          </span>
          <h2 className="mt-2 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
            Moments That Define Our Journey
          </h2>
          <p className="mt-4 text-lg text-slate-600 max-w-2xl leading-relaxed">
            A curated glimpse into our professional milestones, team culture,
            and the commitment to excellence that drives us.
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="columns-1 gap-6 sm:columns-2 lg:columns-3 space-y-6">
          {images.map((img) => (
            <div
              key={img.id}
              className="group relative break-inside-avoid overflow-hidden rounded-2xl bg-white p-3 shadow-md ring-1 ring-slate-200 transition-all duration-500 hover:shadow-2xl hover:ring-red-200"
            >
              {/* Image Container */}
              <div className="relative overflow-hidden rounded-xl bg-slate-100">
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-110"
                  loading="lazy"
                />

                {/* AIA Red Overlay on Hover */}
                <div className="absolute inset-0 bg-gradient-to-t from-red-900/80 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100 flex items-end p-6">
                  <p className="text-white font-bold text-sm transform translate-y-4 transition-transform duration-300 group-hover:translate-y-0">
                    {img.caption}
                  </p>
                </div>
              </div>

              {/* Red Accent Strip (Visible only on hover) */}
              <div className="absolute top-0 left-0 h-1 w-0 bg-red-600 transition-all duration-500 group-hover:w-full"></div>
            </div>
          ))}
        </div>

        {/* Decorative Element */}
        <div className="mt-20 flex justify-center">
          <div className="flex items-center gap-4">
            <div className="h-px w-12 bg-slate-200"></div>
            <p className="text-xs font-bold text-slate-400 uppercase tracking-widest">
              AIA Professional Excellence
            </p>
            <div className="h-px w-12 bg-slate-200"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
